import React from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { Orientation, Variant } from './types'
import { getCurrentCardScaleValue } from './utils/getCardDimensionDetails'

interface CardImageProps {
  orientation: Orientation
  variant: Variant
}

const SharedCardImageStyles = styled.div<CardImageProps>`
  position: absolute;
  transform: ${({ variant, orientation }) => {
    const currentVariant = getCurrentCardScaleValue({
      variant,
      orientation,
    })
    const translateValue = `${currentVariant.x},${currentVariant.y}`
    return `translateZ(0) scale(${currentVariant.scale})
  translate(${translateValue})`
  }};
  will-change: transform;
`

const StyledPortraitCardImage = styled(SharedCardImageStyles)<CardImageProps>`
  width: 78%;
  left: ${({ orientation }) =>
    orientation === Orientation.Square ? '23%' : '25%'};
  bottom: 17%;
  transform-origin: left bottom;
`

const StyledLandscapeCardImage = styled(SharedCardImageStyles)<CardImageProps>`
  width: 111%;
  left: -8%;
  bottom: 10%;

  transform-origin: center bottom;
`

export const StyledCardImageWrapper: React.FC<
  React.PropsWithChildren<CardImageProps>
> = ({ children, ...props }) => {
  const { orientation } = props
  const isLandscape = orientation === Orientation.Landscape

  return (
    <>
      {isLandscape && (
        <StyledLandscapeCardImage {...props}>
          {children}
        </StyledLandscapeCardImage>
      )}

      {!isLandscape && (
        <StyledPortraitCardImage {...props}>{children}</StyledPortraitCardImage>
      )}
    </>
  )
}
